export const luxuryHomes = [
  {
    id: 1,
    rooms: "4+1",
    area: 220,
    type: "Apartment",
    price: 3500000,
    location: "Paris, France",
    listingDate: "05-01-2025",
    salesAgent: "Marie Dubois",
    description:
      "A charming Parisian apartment with a stunning view of the Eiffel Tower.",
    images: {
      exterior: "img/paris-apartment-exterior.jpeg",
      interior: "img/paris-apartment-interior.jpeg",
    },
  },
  {
    id: 2,
    rooms: "5+1",
    area: 300,
    type: "Detached House",
    price: 12500000,
    location: "Zurich, Switzerland",
    listingDate: "05-01-2025",
    salesAgent: "Lukas Meier",
    description:
      "A spacious detached house in Zurich with a large garden and mountain views.",
    images: {
      exterior: "img/zurich-familyhouse-exterior.jpeg",
      interior: "img/zurich-familyhouse-interior.jpeg",
    },
  },
  {
    id: 3,
    rooms: "6+2",
    area: 480,
    type: "Villa",
    price: 25000000,
    location: "Barcelona, Spain",
    listingDate: "04-01-2025",
    salesAgent: "Carlos García",
    description:
      "An elegant villa in Barcelona with a private pool and modern design.",
    images: {
      exterior: "img/barcelona-villa-exterior.jpeg",
      interior: "img/barcelona-villa-interior.jpeg",
    },
  },
  {
    id: 4,
    rooms: "4+1",
    area: 195,
    type: "Apartment",
    price: 2349000,
    location: "Rome, Italy",
    listingDate: "06-01-2025",
    salesAgent: "Giulia Rossi",
    description:
      "A cozy apartment in Rome, perfect for city living near historical landmarks.",
    images: {
      exterior: "img/rome-apartment-exterior.jpeg",
      interior: "img/rome-apartment-interior.jpeg",
    },
  },
  {
    id: 5,
    rooms: "5+2",
    area: 350,
    type: "Castle",
    price: 75000000,
    location: "Bavaria, Germany",
    listingDate: "06-01-2025",
    salesAgent: "Hans Müller",
    description:
      "A majestic castle in Bavaria surrounded by breathtaking landscapes.",
    images: {
      exterior: "img/bavaria-castle-exterior.jpeg",
      interior: "img/bavaria-castle-interior.jpeg",
    },
  },
  {
    id: 6,
    rooms: "5+3",
    area: 500,
    type: "Castle",
    price: 65000000,
    location: "Budapest, Hungary",
    listingDate: "06-01-2025",
    salesAgent: "Eva Kovács",
    description:
      "A historic castle in Budapest with modern amenities and panoramic views.",
    images: {
      exterior: "img/budapest-castle-exterior.jpeg",
      interior: "img/budapest-castle-interior.jpeg",
    },
  },
  {
    id: 7,
    rooms: "4+1",
    area: 220,
    type: "Apartment",
    price: 16800000,
    location: "Amsterdam, Netherlands",
    listingDate: "26-12-2024",
    salesAgent: "Johan de Vries",
    description:
      "A stylish apartment in Amsterdam with canalside views and high ceilings.",
    images: {
      exterior: "img/amsterdam-apartment-exterior.jpeg",
      interior: "img/amsterdam-apartment-interior.jpeg",
    },
  },
  {
    id: 8,
    rooms: "6+1",
    area: 450,
    type: "Villa",
    price: 89000000,
    location: "Prague, Czech Republic",
    listingDate: "06-01-2025",
    salesAgent: "Petr Novák",
    description:
      "A luxurious villa in Prague with a private garden and elegant interiors.",
    images: {
      exterior: "img/prague-villa-exterior.jpeg",
      interior: "img/prague-villa-interior.jpeg",
    },
  },
  {
    id: 9,
    rooms: "4+1",
    area: 320,
    type: "Penthouse",
    price: 49000000,
    location: "Vienna, Austria",
    listingDate: "06-01-2025",
    salesAgent: "Anna Fischer",
    description:
      "An exclusive penthouse in Vienna offering stunning city skyline views.",
    images: {
      exterior: "img/vienna-penthouse-exterior.jpeg",
      interior: "img/vienna-penthouse-interior.jpeg",
    },
  },
  {
    id: 10,
    rooms: "5+1",
    area: 400,
    type: "Detached House",
    price: 20000000,
    location: "Brussels, Belgium",
    listingDate: "06-01-2025",
    salesAgent: "Lucas Dupont",
    description:
      "A charming detached house in Brussels with a modern touch and garden.",
    images: {
      exterior: "img/brussel-familyhouse-exterior.jpeg",
      interior: "img/brussel-familyhouse-interior.jpeg",
    },
  },
  {
    id: 11,
    rooms: "4+1",
    area: 270,
    type: "Apartment",
    price: 4200000,
    location: "Copenhagen, Denmark",
    listingDate: "06-01-2025",
    salesAgent: "Freja Nielsen",
    description:
      "A bright apartment in Copenhagen with Scandinavian design and comfort.",
    images: {
      exterior: "img/Copenhagen-apartment-exterior.jpeg",
      interior: "img/Copenhagen-apartment-interior.jpeg",
    },
  },
  {
    id: 12,
    rooms: "6+2",
    area: 550,
    type: "Villa",
    price: 60000000,
    location: "Stockholm, Sweden",
    listingDate: "06-01-2025",
    salesAgent: "Erik Lindberg",
    description:
      "An exquisite villa in Stockholm with lakefront access and modern luxuries.",
    images: {
      exterior: "img/Stockholm-villa-exterior.jpeg",
      interior: "img/Stockholm-villa-interior.jpeg",
    },
  },
  {
    id: 13,
    rooms: "5+1",
    area: 360,
    type: "Detached House",
    price: 18000000,
    location: "Lisbon, Portugal",
    listingDate: "06-01-2025",
    salesAgent: "Tiago Silva",
    description:
      "A beautiful detached house in Lisbon with a rooftop terrace and ocean views.",
    images: {
      exterior: "img/Lisbon-familyhouse-exterior.jpeg",
      interior: "img/Lisbon-familyhouse-interior.jpeg",
    },
  },
  {
    id: 14,
    rooms: "4+2",
    area: 290,
    type: "Apartment",
    price: 3200000,
    location: "Dublin, Ireland",
    listingDate: "06-01-2025",
    salesAgent: "Aoife Murphy",
    description:
      "A spacious apartment in Dublin with contemporary interiors and amenities.",
    images: {
      exterior: "img/dublin-apartment-exterior.jpeg",
      interior: "img/dublin-apartment-interior.jpeg",
    },
  },
  {
    id: 15,
    rooms: "6+3",
    area: 680,
    type: "Castle",
    price: 95000000,
    location: "Lausanne, Switzerland",
    listingDate: "06-01-2025",
    salesAgent: "Sophie Dubois",
    description:
      "A grand castle in Lausanne with a rich history and breathtaking views.",
    images: {
      exterior: "img/Lousanne-castle-exterior.jpeg",
      interior: "img/Lousanne-castle-interior.jpeg",
    },
  },
  {
    id: 16,
    rooms: "5+1",
    area: 300,
    type: "Apartment",
    price: 15500000,
    location: "Helsinki, Finland",
    listingDate: "06-01-2025",
    salesAgent: "Mikko Laine",
    description:
      "A modern apartment in Helsinki with smart home features and a balcony.",
    images: {
      exterior: "img/helsinki-apartment-exterior.jpeg",
      interior: "img/helsinki-apartment-interior.jpeg",
    },
  },
  {
    id: 17,
    rooms: "4+1",
    area: 230,
    type: "Penthouse",
    price: 5500000,
    location: "Warsaw, Poland",
    listingDate: "06-01-2025",
    salesAgent: "Zofia Kowalska",
    description:
      "A luxurious penthouse in Warsaw with panoramic views and modern design.",
    images: {
      exterior: "img/warsaw-penthouse-exterior.jpeg",
      interior: "img/warsaw-penthouse-interior.jpeg",
    },
  },
  {
    id: 18,
    rooms: "6+2",
    area: 500,
    type: "Villa",
    price: 48000000,
    location: "Oslo, Norway",
    listingDate: "06-01-2025",
    salesAgent: "Olav Hansen",
    description:
      "An elegant villa in Oslo with fjord views and a peaceful atmosphere.",
    images: {
      exterior: "img/oslo-villa-exterior.jpeg",
      interior: "img/oslo-villa-interior.jpeg",
    },
  },
  {
    id: 19,
    rooms: "4+1",
    area: 200,
    type: "Apartment",
    price: 2500000,
    location: "Sofia, Bulgaria",
    listingDate: "06-01-2025",
    salesAgent: "Viktor Ivanov",
    description:
      "A budget-friendly apartment in Sofia with easy access to the city center.",
    images: {
      exterior: "img/sofia-apartment-exterior.jpeg",
      interior: "img/sofia-apartment-interior.jpeg",
    },
  },
  {
    id: 20,
    rooms: "5+1",
    area: 330,
    type: "Detached House",
    price: 28000000,
    location: "Athens, Greece",
    listingDate: "06-01-2025",
    salesAgent: "Nikos Papadopoulos",
    description:
      "A family-friendly detached house in Athens with a large garden and pool.",
    images: {
      exterior: "img/athens-familyhouse-exterior.jpeg",
      interior: "img/athens-familyhouse-interior.jpeg",
    },
  },
];
